/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 841a617c3c67
 */

import * as z from "zod";

/**
 * Sample notification data to evaluate the filter against.
 */
export type SampleData = {};

export const SampleData$zodSchema: z.ZodType<SampleData> = z.object({})
  .describe("Sample notification data to evaluate the filter against.");

export type TestTriggerRequest = { sample_data?: SampleData | undefined };

export const TestTriggerRequest$zodSchema: z.ZodType<TestTriggerRequest> = z
  .object({
    sample_data: z.lazy(() => SampleData$zodSchema).optional().describe(
      "Sample notification data to evaluate the filter against.",
    ),
  });
